import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Clock, Video, ArrowLeft } from 'lucide-react';

export default function ExpertServices() {
  const { id } = useParams();
  const { experts, services } = useApp();

  const expert = experts.find(p => String(p.id) === id);

  if (experts.length === 0) {
    return <div style={{ padding: 40, textAlign: 'center', color: 'var(--ink3)' }}>Loading…</div>;
  }

  if (!expert) return <div style={{ padding: 40, textAlign: 'center' }}>Expert not found.</div>;

  const expertServices = services.filter(s => String(s.expert_id) === id);

  return (
    <div>
      {/* Hero */}
      <div style={{ background: `linear-gradient(135deg, ${expert.bg || '#0B6E65'} 0%, ${expert.bg || '#0B6E65'}CC 100%)`, padding: '40px 0 40px' }}>
        <div className="container">
          <Link to={`/expert/${id}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.15)', color: 'white', border: 'none', padding: '8px 12px', borderRadius: 6, textDecoration: 'none', marginBottom: 20, cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
            <ArrowLeft size={14} /> Back to Profile
          </Link>
        </div>
      </div>

      <div className="container" style={{ padding: '40px 0' }}>
        {/* Menu Tabs */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid var(--border2)' }}>
          <Link to={`/expert/${id}`} style={{ padding: '12px 16px', fontWeight: 600, fontSize: 14, color: 'var(--ink3)', cursor: 'pointer', textDecoration: 'none', transition: 'var(--transition)' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--saffron)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--ink3)'}
          >Profile</Link>
          <div style={{ padding: '12px 16px', fontWeight: 600, fontSize: 14, borderBottom: '2px solid var(--saffron)', color: 'var(--saffron)', cursor: 'pointer' }}>Services & Pricing</div>
        </div>

        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 20 }}>Services Offered by {expert.name}</h1>
        {expertServices.length === 0 ? (
          <p style={{ fontSize: 14, color: 'var(--ink3)' }}>No services listed yet.</p>
        ) : (
          expertServices.map(s => (
            <div key={s.id} style={{ border: '1px solid var(--border2)', borderRadius: 10, padding: 16, marginBottom: 10 }}>
              <div className="flex items-center justify-between">
                <div style={{ fontWeight: 600, fontSize: 15 }}>{s.title}</div>
                <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--saffron)' }}>₹{Number(s.price).toLocaleString()}</div>
              </div>
              <div style={{ fontSize: 13, color: 'var(--ink3)', marginTop: 6, lineHeight: 1.5 }}>{s.description || s.desc}</div>
              <div style={{ fontSize: 12, color: 'var(--ink4)', marginTop: 8, display: 'flex', gap: 12 }}>
                <span><Clock size={12} style={{ display: 'inline' }} /> {s.duration} min</span>
                <span><Video size={12} style={{ display: 'inline' }} /> Live 1:1 video</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
